import React from "react";
import { Container } from "react-bootstrap";
import "./UpcomingTournaments.css";

const tournaments = [
  {
    name: "Back to Basics Challenge",
    date: "25Th October 2025",
    location: "Brookhouse Runda",
    // theme: "Space",
    logo: "/inspire.jpeg",
    status: "Registration Open",
    highlight: true
  },
  {
    name: "International Robot Olympiad",
    date: "17Th - 21St December 2025",
    location: "Gold Coast, Australia",
    theme: "Space ",
    logo: "/iro.png",
    status: "Registration Open",
    highlight: false
  },
  {
    name: "Inspire Robotics Challenge",
    date: "6Th/7Th March 2026",
    location: "St. Andrews Turi, Molo",
    theme: "Climate Change",
    logo: "/inspire.png",
    status: "Coming Soon",
    highlight: false
  },
];

export default function UpcomingTournaments() {
  return (
    <section className="upcoming-tournaments">
      <Container>
        <div className="section-header">
          <h2 className="section-title">
            <span className="title-icon"></span>
            Upcoming STEM Tournaments
            <span className="title-underline"></span>
          </h2>
          <p className="section-subtitle">
            Inspiring young minds through competitive STEM challenges
          </p>
        </div>

        <div className="tournament-grid">
          {tournaments.map((event, index) => (
            <div 
              className={`tournament-card ${event.highlight ? 'featured' : ''}`} 
              key={index}
            >
              <div className="card-header">
                <div className="tournament-logo-container">
                  <img 
                    src={event.logo} 
                    alt={`${event.name} logo`} 
                    className="tournament-logo"
                    onError={(e) => {
                      e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzIiIGN5PSIzMiIgcj0iMzIiIGZpbGw9IiM0Yjc2ODgiLz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeD0iMjAiIHk9IjIwIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMSA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDMgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4KPC9zdmc+';
                    }}
                  />
                </div>
                <div className="status-badge">
                  {event.status}
                </div>
              </div>

              <div className="tournament-content">
                <h3 className="tournament-name">{event.name}</h3>
                
                <div className="tournament-details">
                  <div className="detail-item">
                    <span className="detail-icon">📅</span>
                    <div className="detail-text">
                      <strong>When:</strong> {event.date}
                    </div>
                  </div>
                  
                  <div className="detail-item">
                    <span className="detail-icon">📍</span>
                    <div className="detail-text">
                      <strong>Where:</strong> {event.location}
                    </div>
                  </div>
                  
                  <div className="detail-item">
                    <span className="detail-icon">🎯</span>
                    <div className="detail-text">
                      <strong>Theme:</strong> {event.theme}
                    </div>
                  </div>
                </div>

                <div className="tournament-benefits">
                  <div className="benefit-tag">Critical Thinking</div>
                  <div className="benefit-tag">Teamwork</div>
                  <div className="benefit-tag">Innovation</div>
                    <div className="benefit-tag">Problem-solving</div>
                </div>
              </div>

              <div className="card-footer">
                {/* <button className="learn-more-btn">
                  Learn More
                </button> */}
              </div>
            </div>
          ))}
        </div>

        <div className="contact-section">
          <div className="contact-card">
            <h4>Ready to Join the Challenge?</h4>
            <p>Get your students involved in these exciting STEM competitions</p>
            <div className="contact-details">
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <a href="tel:0728128353">0728 128 353</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <a href="mailto:stemtrix@gmail.com">stemtrix@gmail.com</a>
              </div>
            </div>
            {/* <button className="primary-cta">Register Your School</button> */}
          </div>
        </div>
      </Container>
    </section>
  );
}